import { Pipe, PipeTransform } from '@angular/core';
import { Form } from '../services/generated/models';
import { FormService } from '../services/form.service';

@Pipe({
    name: 'getText',
    pure: false
})
export class GetText implements PipeTransform {

    constructor(private formService: FormService) {}

    transform(key: string): any {
        const that = this;
        let result = key;
        if (that.formService.currentForm != null) {
            const t = that.formService.currentForm.Texts.find(x => x.TextKey === key);
            if (t) {
                result = (t.CustomValue == null || t.CustomValue === '') ? t.DefaultValue : t.CustomValue;
            }
        }
        return result;
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/src/pipes/getText.ts